 <template>
  <div id="app">
    <vuegle-maps :markers="getLocations"/>
    <splash-screen v-if="!appIsActive" />
    <div class="panel-container" v-else>
      <selection-panel class="panel" />
      <location-details-panel class="panel details-panel" :location="getActiveLocation" v-if="getActiveLocation" />
  </div>
      <custom-footer />
  </div>
</template>

<script>
import SelectionPanel from './components/SelectionPanel'
import LocationDetailsPanel from './components/LocationDetailsPanel'
import CustomFooter from './components/CustomFooter'
import VuegleMaps from './components/VuegleMaps'
import SplashScreen from './components/SplashScreen'

import { mapGetters } from 'vuex'

export default {
  name: 'App',
  computed: {
    ...mapGetters([
      'getLocations',
      'getActiveLocation',
      'appIsActive'
    ])
  },
  components: {
    LocationDetailsPanel,
    SelectionPanel,
    CustomFooter,
    VuegleMaps,
    SplashScreen
  }
}
</script>

<style lang="scss" scoped>
@import './assets/variables';

$buffer-sm: 50px;
$buffer-lg: 65px;

.panel-container {
  position: relative;
  width: 100%;
  min-height: calc(100vh - #{$buffer-sm});
  margin-bottom: $buffer-sm; // Accounts for footer
  overflow: hidden;
}

.location-details-panel {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 10;
}

.splash-screen {
position:relative;
}

@media #{$breakpoint-md} {
  .panel-container {
    display: flex;
    align-items: stretch;
  }

  .panel {
    width: 50%;
  }

  .location-details-panel {
    position: relative;
  }

  .splash-screen {
    position: absolute;
    top: 47%;
    left: 50%;
    transform: translate(-50%,-50%);
  }

}

@media #{$breakpoint-lg} {
  .panel-container {
    min-height: calc(100vh - #{$buffer-lg});
    margin-bottom: $buffer-lg; // Accounts for footer
    width: 640px;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue